export default "__VITE_ASSET__D$pxmOU0__"